import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgCleanserMoisturizerDuoGlyph from './svgs/CleanserMoisturizerDuoGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var cleanserMoisturizerDuoGlyph = (props => useIcon(SvgCleanserMoisturizerDuoGlyph, null, props));

export { cleanserMoisturizerDuoGlyph as default };
